import axios from "axios";
import cx from 'classnames';
import React, { useEffect, useState } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  Announcement,
  Button,
  CardAction, Loader, Navbar, ShortDesc, Sidebar,
  Spacer
} from '../../components';
import URL from '../../config/api.json';

function Normal() {

  const [closeSide, setCloseSide] = useState(false)
  const [show, setShow] = useState(true);
  const [network, setNetwork] = useState([])
  const [watchlist, setWatchlist] = useState([])
  const [smoothness, setSmoothness] = useState([]);


  const [inputWa, setInputWa] = useState('')
  const [inputNet, setInputNet] = useState('')
  const [inputSmoothness, setInputSmoothness] = useState('')
  const [processid, setProcessid] = useState('')
  const [tokenInspect, setTokenInspect] = useState([])
  const [hit, setHit] = useState(false)
  const [loading, setLoading] = useState(false)
  const [cad, setCad] = useState([])
  const [initViewData, setInitViewData] = useState(false)
  const [progress, setProgress] = useState(5)

  const subMitWatchlist = async () => {
    const data = {
      address: inputNet,
      network: inputWa
    }
    if (!data.address || !data.network) {
      toast.error("Please fill address and network!")
    } else {
      if (localStorage.token_watchlist) {
        const lists = JSON.parse(localStorage.token_watchlist);
        lists.push(data);
        localStorage.setItem('token_watchlist', JSON.stringify(lists));
        getWatchList()
        setInputNet('')
      } else {
        localStorage.setItem('token_watchlist', JSON.stringify([data]));
        getWatchList()
        setInputNet('')
      }
    }
  }

  const getWatchList = async () => {
    if (localStorage.token_watchlist) {
      const data = await JSON.parse(localStorage.token_watchlist)
      setWatchlist(data)
    }
  }
  const updateLocalWatchlist = (data) => {
    if (localStorage.token_watchlist) {
      const localWL = JSON.parse(localStorage.token_watchlist)
      const newData = [];
      localWL.filter(item => {
        if (item.address !== data.address || item.network !== data.network) {
          newData.push(item);
        }
        localStorage.setItem('token_watchlist', JSON.stringify(newData));
        getWatchList()
      })
    }
  }
  const retriveLocalWatchlist = (data) => {
    setInputNet(data.address)
    setInputWa(data.network)
  }

  const getNetwork = async () => {
    const res = await axios.get(`${URL.API_URL}contract/networks`);
    setNetwork(res.data.data);
  }
  const getSmoothness = async () => {
    const res = await axios.get(`${URL.API_URL}token/smoothness`);
    setSmoothness(res.data.data);
  }

  useEffect(() => {
    getNetwork()
    getWatchList()
    getSmoothness()
  }, [])
  const toggleMenu = () => {
    if (closeSide) {
      setCloseSide(false)
    } else {
      setCloseSide(true)
    }
  }
  const classContentWrapper = cx({
    'scrollCustom': true,
    'contentWrapper': true,
    'wide': closeSide
  })


  const initInspect = async (layer) => {
    if(!inputNet || !inputWa || !inputSmoothness){
      return toast.error("Please provide token and network");
    }
    setHit(false)
    setCad([])
    setLoading(true)
    const res = await axios.get(`${URL.API_URL}token/inspect?address=${inputNet}&network=${inputWa}&layer=${layer}&smoothness=${inputSmoothness}`);
    setProcessid(res.data.data);
    let status = 0;
    while (status < 100) {
      const result = await axios.get(`${URL.API_URL}token/inspect/check?process_id=${res.data.data}`);
      status = result.data.data.progress
      setProgress(status)
      if (status === 100) {
        setHit(true)
        setCad(result.data.data.data.cad)
        setTokenInspect(result.data.data.data)
        setInitViewData(false)
        setLoading(false)
        setProgress(5)
        setInputNet('')
      }
    }
  }

  const retriveData = async () => {
    setLoading(true)
    const result = await axios.get(`${URL.API_URL}token/inspect/check?process_id=${processid}`)
    setHit(true)
    setCad(result.data.data.data.cad)
    setTokenInspect(result.data.data.data)
    setInitViewData(false)
    setInputWa('')
    setInputNet('')
    setLoading(false)
  }

  const TokenSupply = () => {
    if (hit) {
      return (
        <div className="cardContainer">
          <div className="d-flex flex-column">
            <div>Token Name : {tokenInspect.token_name}</div>
            <div>Total Supply : {tokenInspect.total_str}</div>
            <div>Token Creator : {tokenInspect.creator}</div>
            <div>Total Related Wallet : {tokenInspect.related_wallet}</div>
          </div>
        </div>
      )
    }
    return false;
  }

  return (
    <div className="page">
      <Navbar onClick={toggleMenu} closeSide={closeSide} />
      <div className="mainWrapper">
        <Sidebar closeSide={closeSide} />
        <div className={classContentWrapper}>
          <div className="container-fluid">
            <Spacer h={20} />
            {
              show && <Announcement
                varian="dark"
                message="We have not released the token yet, but consider airdrop for those who test the mobile version apps"
                onClick={() => setShow(false)
                } />
            }
            <CardAction />
            <div className="row">
              <div className="col-xl-8">
                <Spacer h={20} />
                <div className="cardContainer">
                  <ShortDesc desc="Retrieve possible other tokens deployed by the creator and its related wallet. This module is also available in" textLink="mobile version telegram bot" link="#/" />
                  <span>Tips:</span>
                  <ul>
                    <li>Consider Mesh Level 3 for ETH Network</li>
                  </ul>
                </div>
                <Spacer h={20} />
                <div className="cardContainer">
                  <div className="formGroup">
                    <div className="mb-3 row">
                      <div className="col-sm-8 mb-2">
                        <input onChange={(e) => setInputNet(e.target.value)} value={inputNet} type="text" className="form-control form-control-lg custom-input" id="inspect_creator" placeholder="Token Address" />
                      </div>
                      <div className="col-sm-4 mb-2">
                        <select onChange={(e) => setInputWa(e.target.value)} className="form-select form-select-lg custom-input">
                          <option value="">Choose network</option>
                          {
                            network.map(net => {
                              return (
                                <option key={net.id} value={net.name}>{net.name}</option>
                              )
                            })
                          }
                        </select>
                      </div>
                    </div>
                    <Button onClick={subMitWatchlist} label="Add To Watchlist" varian="orange light ms-auto" width={200} />
                    <Spacer h={20} />
                    <div className="filterTransaction row align-items-center">
                      <span className="col-lg-12 mb-3">Filter Transaction</span>
                      <div className="col-lg-3">
                        <select onChange={(e) => setInputSmoothness(e.target.value)} className="form-select form-select-lg custom-input">
                          <option disabled value="">Smoothness</option>
                          {
                            smoothness.map(sm => {
                              return (
                                <option key={sm.id} value={sm.name}>{sm.name}</option>
                              )
                            })
                          }
                        </select>
                      </div>
                      <div className="col-lg-9 d-flex align-items-center justify-content-end">

                        <div className="d-flex flex-wrap">
                          {
                            initViewData ?
                              <Button onClick={() => retriveData()} label="Refresh" width={120} varian="orange me-2 my-1 my-lg-0" />
                              : (
                                <>
                                  <Button onClick={() => initInspect(2)} label="2 Layers" varian="orange me-2 my-1 my-lg-0" />
                                  <Button onClick={() => initInspect(3)} label="3 Layers" varian="orange me-2 my-1 my-lg-0" />
                                  <Button label="5 Layers" varian="orange me-2 my-1 my-lg-0 light" disabled />
                                  <Button label="8 Layers" varian="orange light" disabled />
                                </>

                              )
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                  {loading && <Loader />}
                </div>
                <Spacer h={20} />
                <TokenSupply />
                <Spacer h={20} />
                <div className="cardContainer">
                  {
                    loading && <div className="progress">
                      <div className="progress-bar bg-warning progress-bar-striped" role="progressbar" style={{ width: `${progress}%` }} aria-valuenow="10" aria-valuemin="0" aria-valuemax="100">{`${progress.toFixed()} %`}</div>
                    </div>
                  }
                  <table className="table table-borderless">
                    <thead>
                      <tr>
                        <th>No</th>
                        <th>Contract Address</th>
                        <th>Symbol</th>
                        <th>Holder</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        cad && cad.map((item, key) => {
                          return (
                            <tr key={key}>
                              <td>{key + 1}</td>
                              <td>{item.cad}</td>
                              <td>{item.symbol}</td>
                              <td>{item.holder}</td>
                            </tr>
                          )
                        })
                      }
                    </tbody>
                  </table>
                  {/* {loading && <Loader />} */}
                </div>
              </div>
              <div className="col-xl-4">
                <Spacer h={20} />
                <div className="cardContainer">
                  <div className="cardUtil">
                    <span className="titleCard d-block">Token Watchlist</span>
                  </div>
                  <div className="table-responsive tableScroll scrollCustom" style={{ height: 440 }}>
                    <table className="table table-borderless">
                      <thead>
                        <tr>
                          <th></th>
                          <th>No</th>
                          <th>Address</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          watchlist.map((item, key) => {
                            return (
                              <tr key={key}>
                                <td>
                                  <span style={{ cursor: 'pointer' }} onClick={() => updateLocalWatchlist(item)} className="text-danger">
                                    x
                                  </span>
                                </td>
                                <td>{key + 1}</td>
                                <td onClick={() => retriveLocalWatchlist(item)} style={{ cursor: 'pointer' }}>{item.address}</td>
                              </tr>
                            )
                          })
                        }
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <Spacer h={20} />
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  )
}
export default Normal

